module.exports = __webpack_public_path__ + "img/glogo37.24c28d71.png";